import { commonValidators, ValidationRules } from '@/utils/validation';

import { UploadDocumentFormData } from './types';

/**
 * Validation config for the upload document form
 */
export const validationRules: ValidationRules<UploadDocumentFormData> = {
  files: {
    required: true,
    minItems: 1,
    validate: (value: unknown): string | undefined => {
      return commonValidators.requiredArray(value, 'Please select at least one file to upload');
    },
  },
} as const;
